// import { TweenMax } from "gsap";

import {  gsap } from "gsap";
import { Point } from "pixi.js";
import { FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { TextStyleOptions } from "../setting/text/IText";
import { Helper } from "../utils/Helper";
import { IDimOrientation, LayoutDimData, ResizeHelper } from "../utils/ResizeHelper";
import { GameSetting } from "../setting/GameSetting"
import { StageLayer } from "@nolimitcity/slot-launcher/bin/StageLayer";

class debugBg extends PIXI.Graphics {
    constructor() {
        super();
        
        this.beginFill(0x000000, 0.6);
        this.drawRect(0, 0, 300, 40);
        this.endFill();
    }
}

class debugText extends PIXI.Text{
    constructor(txt:string = "",style?:TextStyleOptions) {
        super(txt, style);
        this.alpha = 0.7
    }
}

export class Speedster extends PIXI.Container implements StageLayer {

    protected static readonly layoutDim: IDimOrientation = {
        landscape: {
            scale: new Point(0.75, 0.75),
            position: new Point(260, 150),
        },
        portrait: {
            scale: new Point(0.75, 0.75),
            position: new Point(260, 150)
        }
    };

    protected static readonly  DEFAULT_TXT_STYLE = {
        fontWeight : FontWeight.BOLD,
        fontFamily: "Helvetica",
        align: "center",
        fill: "#FFFFFF",
        fontSize: 34,
        wordWrap: true,
        wordWrapWidth: 500,
        
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 4,
    };

    private static globalSpeed:number = 1;
    private static debugCont:PIXI.Container;
    private static deTxt:string = "Current Speed: ";

    private static tl:gsap.core.Timeline;

    constructor() {
        super();
        if(GameSetting.isDevMode) {
            Speedster.initSpeedController(this);
            
            this.onResize();
        }
        this.name = "Speedster";
    }

    private static get currentText():string{
        return this.deTxt + this.globalSpeed;
    }

    private static get DebugText():debugText{
        return <debugText>this.debugCont.children[1];
    }

    public static pauseGame():void{
        Speedster.globalSpeed = 0.0001;
        Speedster.globalSpeed = parseFloat(Speedster.globalSpeed.toFixed(1));
        gsap.globalTimeline.timeScale(Speedster.globalSpeed);
        Speedster.updateText();     
    }

    protected static initSpeedController(cont:PIXI.Container):void{
        this.debugCont = cont;

        document.addEventListener("keydown", function (e) {
            let updated:boolean = true;
            switch (e.key) {
                case "1": // 1
                case "r": // R
                case "R": // R
                    Speedster.globalSpeed = 1;
                    break;
                case "2":// 2
                    Speedster.globalSpeed = 2;
                    break;
                case "3": // 3
                    Speedster.globalSpeed = 3;
                    break;
                case "4": // 4
                    Speedster.globalSpeed = 4;
                    break;
                case "5": // 5
                    Speedster.globalSpeed = 5;
                case "6": // 5
                    Speedster.globalSpeed = 10;
                    break;
                case "q": // Q
                case "Q": // Q
                    Speedster.globalSpeed = 0.0001;
                    break;
                case "s": // S
                case "S": // S
                    Speedster.globalSpeed = Math.max(Speedster.globalSpeed-0.1,0.1)
                    break;
                case "w": // W
                case "W": // W
                    Speedster.globalSpeed += 0.1;
                    break;
                default:
                    updated = false;
                    break;
            }
            if(updated){
                Speedster.globalSpeed = parseFloat(Speedster.globalSpeed.toFixed(1));
                gsap.globalTimeline.timeScale(Speedster.globalSpeed)
                Speedster.updateText();                
            }
        }, false);

        this.debugCont.addChild(new debugBg())
        this.debugCont.addChild(new debugText(this.currentText,this.DEFAULT_TXT_STYLE))

        this.debugCont.alpha = 0;
    }

    protected static updateText():void{
        Speedster.DebugText.text = Speedster.currentText;

        this.tl = Helper.setTimeline(this.tl!,new gsap.core.Timeline());

        const duration:number = 0.3 * this.globalSpeed;
        const del:number = 0.35 * this.globalSpeed;

        this.tl.fromTo(this.debugCont,{alpha:1},{duration:duration,alpha:0 , delay:del})
        this.tl.play();
    }

    onResize():void{
        const layoutdata: LayoutDimData = ResizeHelper.calcDim(Speedster.layoutDim);
        if(Speedster.debugCont){
            Speedster.debugCont.children.forEach((e) => {
                e.position = layoutdata.position;
                e.scale = layoutdata.scale;
            })
        }
    }
}